import { AppStatuses } from '../gql/graphql';

export const APP_FINISHED_LEASE_STATUSES = [AppStatuses.DocsSigned, AppStatuses.ApprovedForFunding, AppStatuses.ReadyForFunding, AppStatuses.Funded];

export const PAST_APPROVED_STATUSES = [
  AppStatuses.Approved,
  AppStatuses.DocsReady,
  AppStatuses.DocsSigned,
  AppStatuses.ApprovedForFunding,
  AppStatuses.ReadyForFunding,
  AppStatuses.Funded,
];
